import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import { dataAlumnosExamenes, updateAverageEscrito, updateAverageGeneral, updateAverageOral } from 'data/apiConection.js/dataAlumnos';
import { columnsAlumnos2025 } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';
import { dataCursos, dataCursosNiveles } from 'data/apiConection.js/dataCursos';
import { getUsers } from 'data/apiConection.js/dataUsers';
import { FaPrint } from 'react-icons/fa';
import { handle_export } from './utils';

const TableViewAlumnosNextCicle = () => {
  const [alumnos, setAlumnos] = useState([]);
  const [filteredAlumnos, setFilteredAlumnos] = useState([]);
  const [flagUpdate, setFlagUpdate] = useState(false);
  const [cursos, setCursos] = useState([]);
  const [cursosSinLimite, setCursosSinLimite] = useState([]);
  const [filter, setFilter] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');

  // Carga inicial de cursos
  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = await getUsers();
        const cu = await dataCursosNiveles();
        const cuSL = await dataCursos();
        const cuSLF = cuSL.filter(curso => curso.cupo_maximo > 0);

        if (user?.role === 'teacher' && user?.profesor_id) {
          const cuByProfesor = cu.filter(curso => curso.profesor_id === user.profesor_id);
          setCursos(cuByProfesor);
        } else {
          setCursos(cu);
          setCursosSinLimite(cuSLF);
          console.log(cursosSinLimite);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  // Carga de alumnos
  useEffect(() => {
    const fetchData = async () => {
      try {
        await updateAverageOral();
        await updateAverageEscrito();
        await updateAverageGeneral();
        const al = await dataAlumnosExamenes('2025');
        setAlumnos(al);
        setFilteredAlumnos(al);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [flagUpdate]);

  // Filtros
  useEffect(() => {
    let alumnosFiltrados = [...alumnos];

    if (filter.trim() !== '') {
      const value = filter.toLowerCase();
      alumnosFiltrados = alumnosFiltrados.filter(alumno =>
        (alumno.firstName && alumno.firstName.toLowerCase().includes(value)) ||
        (alumno.lastName && alumno.lastName.toLowerCase().includes(value)) ||
        (alumno.curso && alumno.curso.toLowerCase().includes(value))
      );
    }

    if (desde || hasta) {
      const desdeDate = desde ? new Date(desde) : null;
      const hastaDate = hasta ? new Date(hasta) : null;

      alumnosFiltrados = alumnosFiltrados.filter(alumno => {
        if (!alumno.updated_at) return false;
        const updatedDate = new Date(alumno.updated_at);

        return (!desdeDate || updatedDate >= desdeDate) &&
               (!hastaDate || updatedDate <= hastaDate);
      });
    }

    setFilteredAlumnos(alumnosFiltrados);
  }, [filter, desde, hasta, alumnos]);

  const columns = columnsAlumnos2025(flagUpdate, setFlagUpdate, cursos);

  return (
    <div>
      <Row
        className="gx-4 mx-0"
        style={{
          height: '100vh',
          width: '100%',
          marginLeft: '250px',
          padding: '20px',
        }}
      >
        {filteredAlumnos && (
          <Col style={{ height: '100%' }}>
            <AdvanceTableWrapper
              columns={columns}
              data={filteredAlumnos}
              selectionColumnWidth={52}
              sortable
              pagination
              perPage={100}
              rowCount={filteredAlumnos.length}
            >
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Card.Body className="p-3" style={{ flexGrow: 1, overflowY: 'auto' }}>
                  <Card.Header>
                          <Row className="mb-3">
        <Col lg={4}>
          <label>Filtro</label>
          <input
            title="Filtro por nombre , dni o curso"
            type="text"
            placeholder="Buscar por nombre, apellido o curso..."
            className="form-control"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Col>
        <Col lg={3}>
          <label>Desde</label>
          <input
            title="Fecha Desde"
            type="date"
            className="form-control"
            value={desde}
            onChange={(e) => setDesde(e.target.value)}
          />
        </Col>
        <Col lg={3}>
          <label>Hasta</label>
          <input
            title= "Fecha Hasta"
            type="date"
            className="form-control"
            value={hasta}
            onChange={(e) => setHasta(e.target.value)}
          />
        </Col>
        <Col lg={1}><Button title='Exportar datos' onClick={() => handle_export(filteredAlumnos)}><FaPrint /></Button></Col>
      </Row>
                  </Card.Header>
                  <AdvanceTable
                    table
                    headerClassName="bg-light text-800 align-middle"
                    rowClassName="btn-reveal-trigger align-middle"
                    tableProps={{
                      size: 'sm',
                      className: 'fs--1 mb-0 w-100 h-100',
                    }}
                  />
                </Card.Body>
                <Card.Footer>
                  <AdvanceTablePagination table />
                </Card.Footer>
              </Card>
            </AdvanceTableWrapper>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default TableViewAlumnosNextCicle;
